export const SPEAKER_DI_STATUSES = {
  start: 'speaker_di_start',
  ready: 'speaker_di_ready',
  full_ready: 'speaker_di_full_ready',
  error: 'speaker_di_error'
};
